import { Fragment, useState } from "react";
import StandardTwoSectionCard from "../../../../components/ui/cards/StandardTwoSectionCard";
import FiUnderstandingModal from "../utils/guides/modals/FiUnderstandingModal";

function FiEcosytem({ content, showButton, mode = "marketing" }) {
  const [activeFeatureKey, setActiveFeatureKey] = useState(null);
  const closeModalHandler = () => setActiveFeatureKey(null);

  const isDashboard = mode === "dashboard";

  return (
    <Fragment>
      {/* 1. Strip out outer container padding/margins if on the dashboard */}
      <div className={isDashboard ? "" : "standard-container"}>
        <div
          className="fi-ecosystem-container"
          style={{ padding: isDashboard ? "0px" : undefined }}
        >
          {/* 2. Only show the header if we are NOT in dashboard mode */}
          {!isDashboard && (
            <div className="fi-ecosystem-header">
              <div className="fi-ecosystem-heading-intro">
                <h3>{content.tools_intro.heading}</h3>
                <p className="light-description">
                  {content.tools_intro.description}
                </p>
              </div>
              {showButton && (
                <div>
                  <button className="cta-button secondary">
                    {content.tools_intro.connect_bank_cta}
                  </button>
                </div>
              )}
            </div>
          )}

          <div className="fi-ecosystem-body">
            {content.tools.map((tool) => (
              <StandardTwoSectionCard
                key={tool.key}
                heading_color={tool.heading_color}
                title_text={tool.label}
                bg_image={tool.bg_image}
                button_text={tool.cta}
                onButtonClick={() => setActiveFeatureKey(tool.key)}
              >
                <div className="card-content-wrapper">
                  <h3>{tool.heading}</h3>
                  <p className="card-description">{tool.description}</p>
                  <ul className="card-bullets-list">
                    {tool.features.map((feature) => (
                      <li className="card-bullet-item" key={feature}>
                        <img
                          src={`${process.env.PUBLIC_URL}/images/icons/check_green.svg`}
                          className="faq-card-icon"
                          alt={content.tool_card_check_icon_alt}
                        />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </StandardTwoSectionCard>
            ))}
          </div>
        </div>
      </div>

      {activeFeatureKey && (
        <FiUnderstandingModal
          functionalityKey={activeFeatureKey}
          onClose={closeModalHandler}
        />
      )}
    </Fragment>
  );
}

export default FiEcosytem;
